var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1453 8.63125L5.01563 1.13906C4.73861 0.983876 4.42089 0.916767 4.10478 0.946676C3.78867 0.976585 3.48917 1.10209 3.24618 1.30648C3.00319 1.51087 2.82823 1.78444 2.74461 2.09076C2.661 2.39707 2.67269 2.72159 2.77813 3.0211L5.16953 9.99063L2.77813 16.9789C2.69479 17.2145 2.66917 17.4666 2.70342 17.7142C2.73768 17.9617 2.8308 18.1974 2.97498 18.4015C3.11916 18.6056 3.3102 18.7722 3.53205 18.8872C3.75391 19.0022 4.00011 19.0623 4.25 19.0625C4.5185 19.0619 4.78237 18.9925 5.01641 18.8609L5.02344 18.8563L18.1484 11.3508C18.3891 11.2146 18.5893 11.0169 18.7286 10.778C18.8678 10.5391 18.9412 10.2675 18.9412 9.99102C18.9412 9.71449 18.8678 9.44291 18.7286 9.20402C18.5893 8.96512 18.3891 8.76747 18.1484 8.63125H18.1453ZM4.81563 16.8148L6.82813 10.9375H11.125C11.3736 10.9375 11.6121 10.8387 11.7879 10.6629C11.9637 10.4871 12.0625 10.2486 12.0625 10C12.0625 9.75136 11.9637 9.5129 11.7879 9.33709C11.6121 9.16127 11.3736 9.0625 11.125 9.0625H6.8336L4.81641 3.18438L16.7453 9.99141L4.81563 16.8148Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.231194c30908901b218422d56980de40.svg";
export { ForwardRef as ReactComponent };